import { observable } from "mobx";
import { Type } from "class-transformer";
import AttachmentListItem from "./attachmentListItem";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class AttachmentList {
  @observable
  total!: number;

  @observable
  @Type(() => AttachmentListItem)
  attachments!: AttachmentListItem[];

  static ValidationRules = {
    total: { required: true, number: true },
    attachments: { required: true },
  };
}
